import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Grid,
  Container,
  CircularProgress,
} from "@mui/material";
import api from "../../services/api";
import StandardCakeCard from "./StandardCakeCard";
import SharedCartPreview from "../../pages/Cart/SharedCartPreview";
import SharedBanner from "../../components/SharedBanner";

const StandardCakesPage = () => {
  const [cakes, setCakes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [sortOption, setSortOption] = useState("popularity");
  const [currentPage, setCurrentPage] = useState(1);
  const [showCartPreview, setShowCartPreview] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const [cartItems, setCartItems] = useState(() => {
    return JSON.parse(localStorage.getItem("cartItems")) || [];
  });
  const [hideBanner, setHideBanner] = useState(false);

  useEffect(() => {
    document.title = "Standard Cakes";
  }, []);

  useEffect(() => {
    fetchCakes();
  }, [sortOption, currentPage]);

  useEffect(() => {
    localStorage.setItem("cartItems", JSON.stringify(cartItems));
  }, [cartItems]);

  const fetchCakes = async () => {
    setLoading(true);
    try {
      const response = await api.get("/standard-cakes");
      setCakes(response.data);
    } catch (error) {
      console.error("Error fetching cakes:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container disableGutters maxWidth="xl">
      {/* Price increase notice */}
      {!hideBanner && <SharedBanner onClose={() => setHideBanner(true)} />}

      {/* Header & Sorting */}
      <Box sx={{ mt: 4, mb: 2, px: 2 }}>
        <Typography variant="h5" fontWeight="bold" sx={{ mb: 1 }}>
          Our Standard Cakes
        </Typography>
        <Typography variant="body1">
          Crafted to keep things simple — these cakes come as-is with no
          customizations. Need something personalized? Message us for a custom
          quote and pricing.
        </Typography>
      </Box>

      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mt: 4,
          mb: 2,
          px: { xs: 2 },
        }}>
        <Typography variant="subtite1" sx={{ fontWeight: "bold" }}>
          Found {cakes.length} results
        </Typography>
      </Box>

      {/* Cake Grid Layout */}
      <Grid container spacing={3}>
        {loading ? (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
              minHeight: "300px",
            }}>
            <CircularProgress color="primary" size={50} />
            <Typography variant="h6" sx={{ mt: 2, color: "#515151" }}>
              Loading...
            </Typography>
          </Box>
        ) : (
          cakes
            .filter((cake) => cake.isVisible !== false) // hide if explicitly false
            .map((cake) => (
              <Grid
                item
                xs={12}
                sm={6}
                lg={4}
                xl={3}
                key={cake._id}
                sx={{ mb: { xs: 4, md: 0 } }}>
                <StandardCakeCard
                  cake={cake}
                  setShowCartPreview={setShowCartPreview}
                  isProcessing={isProcessing}
                  setIsProcessing={setIsProcessing}
                  isAvailable={cake.isAvailable !== false}
                />
              </Grid>
            ))
        )}
      </Grid>
      <SharedCartPreview
        show={showCartPreview}
        setShowCartPreview={setShowCartPreview}
      />
    </Container>
  );
};

export default StandardCakesPage;
